/**
 * @file   瀑布流
 * @create macaiqi 2025/08/28
 * @update 
 */
import React from 'react'
import { Link } from 'react-router-dom';
import Loading from '../../../components/Loading';
import defaultimg from '../../../assets/images/default.jpg'
import { changePictureSize } from '../../../utils';
import Masonry from 'react-masonry-css';


export default function MasonryList({ data, loading }) {
    // 响应式断点配置
    const breakpointColumns = {
        default: 4, // 默认显示 3 列
        700: 2      // 宽度 < 700px 时显示 2 列
    }; return (loading ? <Loading /> :
        <div className='masonry-container'>

            <Masonry
                breakpointCols={breakpointColumns}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
            >
                {data?.records?.map((item, index) => {
                    return (
                        <div key={item.id}>
                            <Link to={`/DigitalResourceLibrary/Guqin/${item.channelNo}/${item.id}`} className="masonry-item" key={index}>

                                <div className="imgbox">
                                    <img className={item.channelNo === 'Qinqu' ? "cover" : ""} src={item.imgSrc ? (window.ENV_IMG_PREURL + changePictureSize(item.imgSrc, 300)) : defaultimg} alt="" />
                                </div>
                                <p className="title">{item.title}</p>
                            </Link>
                        </div>
                    )
                })}
            </Masonry>
        </div>
    )
}
